// @flow

import _ from 'lodash/fp';
import React from 'react';
import {Field, reduxForm} from 'redux-form';
import BasicFormInput from '../BasicFormInput/BasicFormInput';
import SelectFormInput from '../SelectFormInput/SelectFormInput';

import type {
  RoomTemplateDto,
  RoomTypeDto,
  LimitedProjectDto,
} from '../../dtos';

export type Props = {
  roomTemplate: ?any,
  roomTypes: RoomTypeDto[],
  projects: LimitedProjectDto[],
  roomTemplates: RoomTemplateDto[],
  formValues: any,
  onUserChange: Function,
};

const notArchived =
  _.filter({archived: null});

const includeRoomTemplate = roomTemplate =>
  _.filter(t => t.id === roomTemplate.roomTypeId || !t.archived);

const filterRoomTemplates = roomTemplate =>
  roomTemplate
    ? includeRoomTemplate(roomTemplate)
    : notArchived;

const RoomTemplateForm = ({
  roomTemplate,
  roomTypes,
  projects,
  roomTemplates,
  formValues,
  onUserChange,
}: Props) => (
  <div className="RoomTemplateForm">
    <div className="row">
      <div className="small-6 column">
        <Field
          name="name"
          label="Namn"
          onChange={onUserChange}
          component={BasicFormInput}
          type="text" />
        {!!roomTemplate && !!roomTemplate.id && (
          <Field
            name="roomTypeId"
            label="Rumstyp"
            normalize={value => value ? value.id : null}
            onChange={onUserChange}
            component={SelectFormInput}
            valueKey="id"
            labelKey="name"
            options={filterRoomTemplates(roomTemplate)(roomTypes)} />
        )}
        {(!roomTemplate || !roomTemplate.id) && (
          <div onChange={onUserChange}>
            <label>
              Produktplatser
            </label>
            <label>
              <Field
                name="slots"
                component="input"
                type="radio"
                value="NONE" /> Lägg till manuellt
            </label>
            <Field
              name="roomTypeId"
              label="Rumstyp"
              normalize={value => value ? value.id : null}
              disabled={!formValues || formValues.slots !== 'NONE'}
              onChange={onUserChange}
              component={SelectFormInput}
              valueKey="id"
              labelKey="name"
              options={roomTypes} />
            <label>
              <Field
                name="slots"
                component="input"
                type="radio"
                value="ROOM" /> Kopiera från rum
            </label>
            <Field
              name="project"
              component={SelectFormInput}
              normalize={value => value ? value : null}
              disabled={!formValues || formValues.slots !== 'ROOM'}
              placeholder="Välj projekt"
              valueKey="id"
              labelKey="name"
              options={projects} />
            <Field
              name="config"
              component={SelectFormInput}
              normalize={value => value ? value : null}
              disabled={!formValues || formValues.slots !== 'ROOM' || !formValues.project}
              placeholder="Välj konfiguration"
              valueKey="id"
              labelKey="name"
              options={!!formValues && !!formValues.project ? formValues.project.apartmentConfigs : []} />
            <Field
              name="basedOnRoomId"
              component={SelectFormInput}
              normalize={value => value ? value.id : null}
              disabled={!formValues || formValues.slots !== 'ROOM' || !formValues.project || !formValues.config}
              placeholder="Välj rum"
              valueKey="id"
              labelKey="name"
              options={!!formValues && !!formValues.config ? formValues.config.rooms : []} />
            <label>
              <Field
                name="slots"
                component="input"
                type="radio"
                value="TEMPLATE" /> Basera på mall
            </label>
            <Field
              name="basedOnTemplateId"
              component={SelectFormInput}
              normalize={value => value ? value.id : null}
              disabled={!formValues || formValues.slots !== 'TEMPLATE'}
              placeholder="Välj mall"
              valueKey="id"
              labelKey="name"
              options={roomTemplates} />
          </div>
        )}
      </div>
    </div>
  </div>
);

export default reduxForm({
  form: 'roomTemplate',
  enableReinitialize: true,
})(RoomTemplateForm);



// WEBPACK FOOTER //
// ./src/components/RoomTemplateForm/RoomTemplateForm.js